import { Observable, Subscription, firstValueFrom } from 'rxjs';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, first } from 'rxjs/operators';
import { MeetingSchedulerStoreService } from '../../data-providers/meeting-scheduler-store.service';
export interface DeleteBookingLinkConfirmationDialogData {
  confirmationCallback: () => Observable<void>;
  entityID: string;
  category: string;
  validateAssociation: boolean;
}

@Component({
  selector: 'meeting-scheduler-delete-booking-link-confirmation-dialog',
  templateUrl: './delete-booking-link-confirmation-dialog.component.html',
  styleUrls: ['./delete-booking-link-confirmation-dialog.component.scss'],
  standalone: false,
})
export class DeleteBookingLinkConfirmationDialogComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];
  working = false;
  @Input() entityID?: string;
  @Input() category?: string;
  @Input() validateAssociation?: boolean;

  constructor(
    private readonly ref: MatDialogRef<DeleteBookingLinkConfirmationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: DeleteBookingLinkConfirmationDialogData,
    private readonly meetingSchedulerStoreService: MeetingSchedulerStoreService,
  ) {}

  categoryTitle: string;
  categoryContent: string;
  categoryDoNotDelete: string;
  categoryDoDelete: string;
  showLoader: boolean;
  group: string[];
  service: string[];
  allowEntityDeletion: boolean;

  ngOnInit(): void {
    this.allowEntityDeletion = false;
    if (this.data.validateAssociation) {
      this.fetchAssociationDetails(this.data.entityID);
    } else {
      this.allowEntityDeletion = true;
    }
    this.setCategoryTranslations(this.data.category, true);
  }

  async fetchAssociationDetails(id: string): Promise<void> {
    this.showLoader = true;
    const response = await firstValueFrom(this.meetingSchedulerStoreService.getEntityAssociation(id));
    if (response.groups || response.services) {
      this.service = response.services;
      this.group = response.groups;
      this.allowEntityDeletion = false;
      this.showLoader = false;
      this.setCategoryTranslations(this.data.category, false);
      return;
    }
    this.showLoader = false;
    this.allowEntityDeletion = true;
  }

  setCategoryTranslations(category: string, isDeletable: boolean): void {
    let prefix = `MEETING_SCHEDULER.BOOKING_LINK.`;
    if (category != undefined) {
      prefix = `${prefix}${category.toUpperCase()}.`;
    }
    let prefixTitle = prefix;
    if (!isDeletable) {
      prefixTitle = prefix + 'CANNOT_';
    }
    this.categoryTitle = `${prefixTitle}DELETE_TITLE`;
    this.categoryContent = `${prefixTitle}DELETE_CONTENT`;
    this.categoryDoNotDelete = `${prefix}DO_NOT_DELETE`;
    this.categoryDoDelete = `${prefix}DO_DELETE`;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onNoClick(): void {
    this.ref.close(false);
  }

  onYesClick(): void {
    this.working = true;
    this.subscriptions.push(
      this.data
        .confirmationCallback()
        .pipe(
          first(),
          finalize(() => (this.working = false)),
        )
        .subscribe({
          next: () => {
            this.ref.close(true);
          },
        }),
    );
  }
}
